import React from "react";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import Logo from "./Logo.png";

// Styled components
const Wrapper = styled(Box)({
  height: "100%",
  width: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
});

const Flow = styled(Box)(({ theme }) => ({
  backgroundColor: "#fff",
  borderRadius: "3px",
  width: "100%",
  maxWidth: 1200,
  maxHeight: 800,
  height: "100%",
  overflow: "auto",
  display: "flex",
  boxShadow: "0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23)",
  [theme.breakpoints.down("sm")]: {
    display: "block",
  },
}));

const Sidebar = styled(Box)(({ theme }) => ({
  backgroundColor: "#393A39",
  color: "#fff",
  width: 150,
  position: "relative",
  padding: 10,
  [theme.breakpoints.down("sm")]: {
    width: "100%",
  },
}));

const LogoImage = styled("img")({
  width: "100%",
  maxWidth: 100,
});

const StepContent = styled(Box)(({ theme }) => ({
  width: "calc(100% - 150px)",
  padding: 40,
  overflow: "auto",
  [theme.breakpoints.down("sm")]: {
    width: "100%",
  },
}));

const StepNumber = styled(Typography)({
  color: "#9C9C9C",
  marginBottom: 20,
});

const BackButton = styled(Box)({
  color: "#9C9C9C",
  position: "absolute",
  bottom: 20,
  width: "100%",
  textAlign: "center",
  cursor: "pointer",
});

// Helper to render step content
function renderCurrentStep(currentStep) {
  return currentStep;
}

// Main component
function AuthenticationFlow({ style, currentStep, steps, onGoBack, onLogout }) {
  return (
    <Wrapper>
      <Flow style={style || {}}>
        <Sidebar>
          <LogoImage alt="Slate logo" src={Logo} />
          {currentStep === 0 && onLogout && (
            <BackButton onClick={onLogout}>Logout</BackButton>
          )}
          {currentStep !== 0 && (
            <BackButton onClick={onGoBack}>Back</BackButton>
          )}
        </Sidebar>
        <StepContent>
          {steps.length > 1 && (
            <StepNumber variant="body2">Step {currentStep + 1}</StepNumber>
          )}
          {renderCurrentStep(steps[currentStep])}
        </StepContent>
      </Flow>
    </Wrapper>
  );
}

export default AuthenticationFlow;
